import React, { useEffect, useState } from 'react';
import translateFile from "../../config/TranslateFile.jsx"

const Footer = () => {
  const currentLang = translateFile();
  return (
    <footer class="footer app-footer" style={{ zIndex: 11 }}>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="copyright text-left text-md-start">
              <p className="mb-0 padd-right-100 font-size-13">
                {currentLang?.Copyright} {new Date().getFullYear()} {currentLang?.by_Inmate_Inbox} &nbsp;
                <a href="/termsofservice" target="_blank" className="text-default-red">{currentLang?.Terms_of_service} </a>&nbsp;&&nbsp;
                <a href="/privacypolicy" target="_blank" className="text-default-red">{currentLang?.Privacy_Policy}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
